import { InMemoryPasskeyStorage } from '@train-protocol/auth';
const STORAGE_KEY = 'passkey-credentials';
/** Persistent IndexedDB-backed storage for passkey credential IDs. */
export class IndexedDBPasskeyStorage {
    constructor(storage) {
        this.storage = storage;
        this.memory = new InMemoryPasskeyStorage();
    }
    /** Load credentials from IndexedDB into memory. Call after SecureStorage.init(). */
    async init() {
        try {
            const stored = await this.storage.getJSON(STORAGE_KEY);
            if (stored && Array.isArray(stored.ids)) {
                for (const id of stored.ids)
                    this.memory.storeCredentialId(id);
                // Restore active (storeCredentialId sets last added as active, so re-set)
                if (stored.activeId && stored.ids.includes(stored.activeId)) {
                    this.memory.storeCredentialId(stored.activeId);
                }
            }
        }
        catch { /* ignore corrupt data */ }
    }
    getActiveCredentialId() {
        return this.memory.getActiveCredentialId();
    }
    getAllCredentialIds() {
        return this.memory.getAllCredentialIds();
    }
    async storeCredentialId(credId) {
        this.memory.storeCredentialId(credId);
        await this.persist();
    }
    async removeCredentialId(credId) {
        this.memory.removeCredentialId(credId);
        await this.persist();
    }
    async persist() {
        try {
            await this.storage.setJSON(STORAGE_KEY, {
                ids: this.getAllCredentialIds(),
                activeId: this.getActiveCredentialId(),
            });
        }
        catch { /* storage error, in-memory still valid */ }
    }
}
